// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
const ReactRedux = require('react-redux')
const { Router } = require('react-router')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ErrorBoundary = require('client-v2/common/components/error/boundary')
const ErrorTester = require('client-v2/common/components/error/tester')
const IconsLoader = require('client-v2/common/containers/icons/loader-component')
const {
  EmbeddedPlayerManager
} = require('client-v2/common/contexts/embedded-player')
const {
  ModalDepthManager,
  ModalDepthBodyEffect
} = require('client-v2/common/contexts/modal-depth')

/**
 * This propagates Redux and Router state down to child components
 * The actual markup is represented in the `WrappedComponent`
 */
module.exports = function (WrappedComponent) {
  function RootComponent(props) {
    return (
      tag(ErrorBoundary,
        tag(ReactRedux.Provider, {
          store: props.store
        },
          tag(IconsLoader),
          tag(ErrorTester),
          tag(Router, {
            history: props.history
          },
            tag(ModalDepthManager,
              tag(ModalDepthBodyEffect),
              tag(EmbeddedPlayerManager,
                tag(WrappedComponent)
              )
            )
          )
        )
      )
    )
  }

  RootComponent.propTypes = {
    history: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  RootComponent.factory = React.createFactory(RootComponent)

  return RootComponent
}
